import * as Sentry from '@sentry/react';
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { googleLogout } from '@react-oauth/google';

import { QUERY_KEY as USER_PROFILE_QUERY_KEY } from '~/services/useUserProfileQuery';
import { tokenManager } from '~/services/TokenManager';
import { trackEvent } from '~/gtag';
import { createLogger } from '~/utils/logging';

const log = createLogger('useLogoutMutation');

export function useLogoutMutation() {
  const queryClient = useQueryClient();

  const mutate = useCallback(async () => {
    log.debug('Logging out user');
    // Immediately signal "no user" so AuthLayout redirects to /login.
    queryClient.setQueryData([USER_PROFILE_QUERY_KEY], null);
    // revoke() clears the token synchronously (disabling query refetches),
    // then revokes the refresh token on the server asynchronously.
    await tokenManager.revoke();
    // Clear remaining stale data so it doesn't flash on next login.
    queryClient.clear();
    googleLogout();
    log.info('Logged out user');
    trackEvent('logout');
    Sentry.setUser(null);
  }, [queryClient]);

  return {
    mutate,
  };
}
